import { get } from 'lodash'
import React from 'react'
import { connect } from 'react-redux'

const Loading1 = ({ isLoading }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <div className="spinner-border  text-primary" role="status" aria-hidden="true">
        <span className="sr-only"> </span>
      </div>
    </div>
  )
}
export default connect(
  (state) => ({
    isLoading: get(state, 'loading.showLoading'),
  }),
  {},
)(Loading1)
